import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { EVENT_CONTENT, type EventContent } from "@tih/shared";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { SiteAtmosphere } from "./SiteAtmosphere";
import { TweaksPanel } from "./TweaksPanel";
import { ScrollToTop } from "./ScrollToTop";
import { SiteAnnouncementBanner } from "./SiteAnnouncementBanner";
import { fetchEvent } from "../api/client";
import { EventContentProvider } from "../context/EventContentContext";
import { applyEventTheme } from "../lib/event-theme";

export function Layout() {
  const [content, setContent] = useState<EventContent | null>(null);

  useEffect(() => {
    fetchEvent()
      .then((data) => {
        setContent(data);
        applyEventTheme(data.theme);
      })
      .catch(() => {
        /* Resolve so `/` can leave BootSplash without flashing HomePage. */
        setContent({
          ...EVENT_CONTENT,
          posterUrl: null,
          eventId: null,
          eventTitle: null,
          eventPhase: null,
          brandingSource: "default",
          status: null,
          publicMessage: null,
          cancellation: null,
          venueMap: null,
        });
      });
  }, []);

  return (
    <EventContentProvider content={content}>
      <SiteAtmosphere />
      <ScrollToTop />
      <SiteAnnouncementBanner />
      <Nav />
      <main id="top">
        <Outlet context={content} />
      </main>
      <Footer />
      <TweaksPanel />
    </EventContentProvider>
  );
}
